type Env = {
  REACT_APP_API_URL: string | undefined;
  REACT_APP_SELF_URL: string | undefined;
  REACT_APP_WEB_ASSISTANT_STATE_UACP: string;
  REACT_APP_WEB_ASSISTANT_PRODUCT: string;
  REACT_APP_WEB_ASSISTANT_VERSION: string;
  REACT_APP_WEB_ASSISTANT_APP_NAME: string;
  REACT_APP_PAGINATION_SIZE: string;
  REACT_APP_EMAIL_VIA_BACKEND: string | boolean;
  REACT_APP_REACT_ENABLE_UPDATE_SUPPLIER: string | boolean;
  REACT_APP_UPDATE_SUPPLIERS_JSON: string | undefined;
  REACT_APP_ALLOW_QUERY_TRACKER_IMPORTS: string;
  REACT_APP_DOCS_LSP: string;
  REACT_APP_DOCS_INTERNAL: string;
  REACT_APP_ALLOW_CORPORATE_CONTENT_QUERY_CREATION: string;
  REACT_APP_ALLOW_MARKETING_QUERY_CREATION: string;
  REACT_APP_ALLOW_ABAP_QUERY_CREATION: string;
  REACT_APP_ALLOW_NOTES_QUERY_CREATION: string;
  REACT_APP_ENTRAID_CLIENT_ID: string | undefined;
  REACT_APP_ENTRAID_AUTHORITY: string | undefined;
  REACT_APP_ENTRAID_LOGIN_SCOPES: string | undefined;
  REACT_APP_ENTRAID_API_SCOPES: string | undefined;
  REACT_APP_ENTRAID_INTERACTION_TYPE: string | undefined;
  REACT_APP_NOTES_URL: string | undefined;
  REACT_APP_USE_HORIZON_THEME: string;
  REACT_APP_ENABLE_SUBSCRIPTIONS: string;
  REACT_APP_MAX_DOWNLOAD_QUERIES_RESULT_FOR_INTERNAL_USER: string;
  REACT_APP_MAX_DOWNLOAD_QUERIES_RESULT_FOR_EXTERNAL_USER: string;
};

// @ts-ignore
const windowEnv: Env | undefined = window.env;
const isCypressTest = process.env.REACT_APP_IS_CYPRESS_TEST === 'true';
export const env =
  process.env.NODE_ENV === 'production' && !isCypressTest ? windowEnv : process.env;
